import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAPI } from '../api/callAPI';
import { setAppConfigs, setFetchingAppConfig } from '../redux/action';
import { get, isArray } from 'lodash';

const AppInitializer = ({ children, onConfigLoaded }) => {
  const dispatch = useDispatch();
  const { endpoint } = useSelector((state) => state.auth);

  const getAppConfigs = async () => {
    if (!endpoint) {
      // Wait for endpoint to be set
      return;
    }

    dispatch(setFetchingAppConfig(true));

    try {
      const response = await getAPI(endpoint, 'app_configs');

      if (response.success) {
        const configs = get(response, 'data.config_list', []);
        const country = get(response, 'data.countries', []);
        
        dispatch(setAppConfigs(configs, country));
        dispatch(setFetchingAppConfig(false));

        // Process configs into object for easy access (optional)
        const configObj = {};
        if (isArray(configs)) {
          configs.forEach((cI) => {
            const key = cI.item;
            const val = cI.body;
            configObj[key] = val;
          });
        }

        // Handle special config flags if needed
        // Example: force app update, broadcast notices, etc.
        if (configObj.force_app_update === '1') {
          // Handle force update logic
          console.warn('Force app update required');
        }

        if (configObj.app_broadcast_notice === '1') {
          // Show broadcast notice modal
          console.log('App broadcast notice enabled');
        }

        // Call callback when configs are loaded
        if (onConfigLoaded) {
          onConfigLoaded(country);
        }
      } else {
        dispatch(setFetchingAppConfig(false));
        if (onConfigLoaded) {
          onConfigLoaded([]);
        }
      }
    } catch (error) {
      console.error('Error fetching app configs:', error);
      dispatch(setFetchingAppConfig(false));
      // Proceed with app initialization even if API call fails
      if (onConfigLoaded) {
        onConfigLoaded([]);
      }
    }
  };

  useEffect(() => {
    if (endpoint) {
      getAppConfigs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint]);

  return <>{children}</>;
};

export default AppInitializer;

